export default "__VITE_ASSET__CJocrNwF__"